/*eslint no-console: 0*/

import React from 'react';
import PropTypes from 'prop-types';
import Relay from 'react-relay';
import {getChannelView} from './channelHandlers';
import {wrapNotFound} from '../app/NotFoundHandler.react';
import {injectIntl, IntlShape} from 'react-intl';
import meQuery from '../queries/MeQuery';
import {renderLoadingPanel} from '../loadingLine/renderLoadingPanel.react';
import {getLastOrganisationId} from '../app/LastOrganisationId';
import { User } from '../../common/types/types';

interface ChannelViewProps {
 intl?: object;
 relay?: object;
 user: User;
}

class ChannelView extends React.Component<ChannelViewProps> {
    static propTypes = {
        intl: PropTypes.object,
        relay: PropTypes.object,
        user: PropTypes.object.isRequired,
    };

    static contextTypes = {
        router: PropTypes.object
    };

    constructor(props) {
        super(props);

        this.state = {
            isLoading: true
        };

        this.timestamp = String(Date.now());
    }

    render() {
        let viewHandler = getChannelView(this.props.user.organisation.channel.channelDef.type);

        if (!Relay.isContainer(viewHandler)) {
            throw new Error('The channel view expects only Relay.container for now.');
        }

        const queryConfig = {
            queries: meQuery,
            name: 'User',
            params: {
                organisationId: this.props.user.organisation.realId,
                channelId: this.props.user.organisation.channel.realId,
                timestamp: this.timestamp
            }
        };

        return (
            <div>
                <Relay.Renderer
                    Container={viewHandler}
                    environment={Relay.Store}
                    onReadyStateChange={({aborted, done, error}) => {
                        if ((aborted || done || error) && this.state.isLoading) {
                            setTimeout(() => {
                                this.setState({
                                    isLoading: false
                                });
                            }, 0);
                        }
                    }}
                    queryConfig={queryConfig}
                />
                { this.state.isLoading ? renderLoadingPanel() : null }
            </div>
        );
    }
}

export default Relay.createContainer(wrapNotFound(injectIntl(ChannelView), (props) => {
    return props.user.organisation && props.user.organisation.channel;
}), {
    initialVariables: {
        organisationId: '',
        channelId: '',
    },
    prepareVariables (variables) {
        if (!variables.organisationId) {
            variables.organisationId = getLastOrganisationId();
        }

        return variables;
    },
    fragments: {
        user: () => Relay.QL`
            fragment on User {
                featureFlags,
                organisation(id: $organisationId) {
                    id,
                    realId,
                    channel(id: $channelId) {
                        realId,
                        channelDef {
                            realId,
                            type
                        }
                    }
                }
            }
        `,
    },
});
